// third-party
import { FormattedMessage } from "react-intl";
// import { useTranslation } from "react-i18next";
// assets
import {
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
  IconSettings,
  IconSlideshow,
  IconHome,
  IconHome2,
  IconUser,
  IconGlobe,
  IconKey
} from "@tabler/icons-react"
import { GiPostOffice } from "react-icons/gi";
import { FcDepartment } from "react-icons/fc";
import React, { useState, useEffect, useContext } from "react";


// constant
const icons = {
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
  IconSettings
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const emailNotifications = {
  id: "email_et_Notifications1",
  title: ["D. ",<FormattedMessage id="email_et_Notifications" />],
  type: "group",
  icon: <IconMail />, // Use a valid icon component here


  /* children: [
   
          {
            id: "cadastrarMails",
            title: <FormattedMessage id="mail_e_notificacao_visualizar" />,
            type: "collapse",
            icon: icons.IconMail, */
            children: [
              {
                id: "mailsRead",
                title: <FormattedMessage id="mail_e_notificacao" />,
                type: "item",
                url: "/emailnotifications/EmailNew",

               //  url: "/emailnotifications/NotificationList",
                // '/user/social-profile/posts'
              },
              
  
            ],
        //  },
  //  ],
};

  



export default emailNotifications;
